function titleCaseWords(value) {
  return String(value || "")
    .split(" ")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}

function normalizeAcronyms(value) {
  return value
    .replace(/\bUk\b/g, "UK")
    .replace(/\bPsc\b/g, "PSC")
    .replace(/\bSic\b/g, "SIC")
    .replace(/\bLtd\b/g, "Ltd")
    .replace(/\bPlc\b/g, "PLC")
    .replace(/\bLlp\b/g, "LLP")
    .replace(/\bLlc\b/g, "LLC");
}

export function formatCompanyHouseCompanyType(value) {
  const rawValue = String(value || "").trim();
  if (!rawValue) return "";

  const normalized = normalizeAcronyms(titleCaseWords(rawValue));

  return normalized
    .replace("Company By Guarantee", "Company by Guarantee")
    .replace("Without Share Capital", "without Share Capital")
    .replace("Use Of", "use of");
}

export function formatCompanyHouseStatus(value) {
  const rawValue = String(value || "").trim();
  if (!rawValue) return "";

  return normalizeAcronyms(titleCaseWords(rawValue))
    .replace("To Strike Off", "to Strike Off")
    .replace("Active Proposal", "Active Proposal");
}

export function formatCompanyHouseFacetValue(facetType, value) {
  if (facetType === "companyType") {
    return formatCompanyHouseCompanyType(value);
  }

  if (facetType === "companyStatus") {
    return formatCompanyHouseStatus(value);
  }

  if (facetType === "officerStatus") {
    return normalizeAcronyms(titleCaseWords(value));
  }

  if (facetType === "officerRole") {
    return normalizeAcronyms(titleCaseWords(String(value || "").replace(/-/g, " ")));
  }

  if (facetType === "pscStatus") {
    return normalizeAcronyms(titleCaseWords(value));
  }

  if (facetType === "pscKind") {
    const normalizedValue = String(value || "").trim().toLowerCase();
    if (normalizedValue === "person") {
      return "Person";
    }
    if (normalizedValue === "other_entity") {
      return "Other Entity";
    }
    return normalizeAcronyms(titleCaseWords(String(value || "").replace(/[-_]/g, " ")));
  }

  return String(value || "").trim();
}
